function initPriceSlider(context) {
  const sliderEl = context.querySelector(".js-price-slider");
  const minPriceInput = context.querySelector(".js-min-price-input");
  const maxPriceInput = context.querySelector(".js-max-price-input");

  if (!sliderEl || !minPriceInput || !maxPriceInput) return;
  if (sliderEl.dataset.rsInitialized) return;
  sliderEl.dataset.rsInitialized = '1';

  let minPrice = parseInt(sliderEl.dataset.min_price);
  const maxPrice = parseInt(sliderEl.dataset.max_price);
  let startPrice = parseInt(sliderEl.dataset.start_price);
  let endPrice = parseInt(sliderEl.dataset.end_price);

  if (minPrice === maxPrice) { minPrice = minPrice - 1; }
  if (startPrice === endPrice) { startPrice = startPrice - 1; }

  startPrice = Math.max(minPrice, Math.min(startPrice, maxPrice));
  endPrice = Math.max(minPrice, Math.min(endPrice, maxPrice));

  const step = Math.max(1, Math.round((maxPrice - minPrice) / 500));

  const hiddenInput = document.createElement('input');
  hiddenInput.type = 'hidden';
  sliderEl.parentNode.insertBefore(hiddenInput, sliderEl);

  const rsInstance = new rSlider({
    target: hiddenInput,
    values: { min: minPrice, max: maxPrice },
    step: step,
    range: true,
    tooltip: false,
    set: [startPrice, endPrice],
    onChange: function() {
      const parts = hiddenInput.value.split(',');
      minPriceInput.value = parts[0];
      maxPriceInput.value = parts[1];
    }
  });

  minPriceInput.addEventListener('change', function() {
    const typed = parseInt(this.value);
    if (isNaN(typed)) return;
    const newMin = Math.max(minPrice, Math.min(Math.round((typed - minPrice) / step) * step + minPrice, maxPrice));
    const curMax = parseInt(maxPriceInput.value) || endPrice;
    rsInstance.setValues(newMin, curMax);
  });

  maxPriceInput.addEventListener('change', function() {
    const typed = parseInt(this.value);
    if (isNaN(typed)) return;
    const curMin = parseInt(minPriceInput.value) || startPrice;
    const newMax = Math.max(minPrice, Math.min(Math.round((typed - minPrice) / step) * step + minPrice, maxPrice));
    rsInstance.setValues(curMin, newMax);
  });
}

document.addEventListener("DOMContentLoaded", function(event) {
  const mobileFilter = document.querySelector('.mobile-filter');
  const desktopFilter = document.querySelector('.column-filter');

  // Инициализируем слайдер цены в десктопном фильтре
  if (desktopFilter) initPriceSlider(desktopFilter);

  // Слайдер цены в мобильном фильтре — при первом открытии
  const filterBtn = document.querySelector('.filter-btn');
  if (filterBtn && mobileFilter) {
    let initialized = false;
    filterBtn.addEventListener('click', function() {
      if (initialized) return;
      requestAnimationFrame(function() {
        initPriceSlider(mobileFilter);
        initialized = true;
      });
    });
  }
});



